// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__2audE","twitter":"nav_twitter__1hAZk"};